import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-number-one-large.tsx
/**
* icon.24.number.one.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyIDNhOSA5IDAgMSAxIDAgMTggOSA5IDAgMCAxIDAtMThtMCAxYTggOCAwIDEgMCAwIDE2IDggOCAwIDAgMCAwLTE2bS0uMjI0IDQuMDUzYS41LjUgMCAwIDEgLjcyNC40NDdWMTVIMTRhLjUuNSAwIDAgMSAwIDFoLTRhLjUuNSAwIDAgMSAwLTFoMS41VjkuMzA5bC0xLjI3Ni42MzhhLjUuNSAwIDAgMS0uNDQ4LS44OTR6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=24950-58680
*/
const Icon24NumberOneLarge = memo(function Icon24NumberOneLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18m0 1a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-.224 4.053a.5.5 0 0 1 .724.447V15H14a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1h1.5V9.309l-1.276.638a.5.5 0 0 1-.448-.894z"
		})
	});
});
//#endregion
export { Icon24NumberOneLarge };

//# sourceMappingURL=icon-24-number-one-large.js.map